export default __webpack_public_path__ + "static/media/icomoon.bef8fa9a.eot";